import { render, staticRenderFns } from "./ModalProjectRemove.vue?vue&type=template&id=2bac5ba0&lang=pug"
import script from "./ModalProjectRemove.vue?vue&type=script&lang=js"
export * from "./ModalProjectRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports